import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router'

export const useQuery = () => {
    const { search } = useLocation()

    return useMemo(() => new URLSearchParams(search), [search])
}

export const useUpdateQuery = () => {
    const query = useQuery()
    const navigate = useNavigate()

    return (param: string, value: string | null) => {
        if (value) {
            query.set(param, value)
        } else {
            query.delete(param)
        }
        navigate(`?${query.toString()}`, { replace: true })
    }
}
